import React, { useContext, useMemo } from "react";
import EditorParent from "@/base-components/EditorParent";
import { Context } from "@/App";
import ImportTable, { ImportColumn } from "./ImportTable";
import { createCustomer } from "@/api/customer-controller";
import { Customer } from "@/model/customer";

const CustomerImportPage: React.FC = () => {
    const { translations } = useContext(Context);
    const t = translations.model.customer;

    const columns: ImportColumn<Customer>[] = useMemo(() => [
        { header: t.externalId, fieldKey: "externalId", type: "string" },
        { header: t.isCompany, fieldKey: "isCompany", type: "boolean" },
        { header: t.firstName, fieldKey: "firstName", type: "string" },
        { header: t.lastName, fieldKey: "lastName", type: "string" },
        { header: t.identificationNumber.id, fieldKey: "identificationNumber", type: "string" },
        { header: t.vatNumber, fieldKey: "vatNumber", type: "string" },
        { header: t.primaryContact, fieldKey: "primaryContact", type: "string" },
        { header: t.email, fieldKey: "email", type: "string" },
        { header: t.phone, fieldKey: "phone", type: "string" },
        { header: t.address, fieldKey: "address", type: "string" },
        { header: t.postalCode, fieldKey: "postalCode", type: "string" },
        { header: t.city, fieldKey: "city", type: "string" },
        { header: t.notes, fieldKey: "notes", type: "string" },
    ], [t]);

    const buildPayload = (rowData: Record<string, any>) => ({
        id: 0,
        externalId: rowData.externalId || "",
        isCompany: rowData.isCompany || false,
        firstName: rowData.firstName || "",
        lastName: rowData.lastName || "",
        identificationNumber: rowData.identificationNumber || "",
        vatNumber: rowData.vatNumber || "",
        primaryContact: rowData.primaryContact || "",
        email: rowData.email || undefined,
        phone: rowData.phone || "",
        address: rowData.address || "",
        postalCode: rowData.postalCode || "",
        city: rowData.city || "",
        notes: rowData.notes || "",
        worksites: [],
        attachedFiles: [],
        propertyValues: [],
    });

    return (
        <EditorParent title={translations.importExport.customerImport}>
            <ImportTable<Customer>
                columns={columns}
                createFn={createCustomer}
                buildPayload={buildPayload}
            />
        </EditorParent>
    );
};

export default CustomerImportPage;
